var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartPoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00224 1.99869C3.55577 1.99869 4.00449 2.4464 4.00449 2.99869V20.0013H20.9978C21.5513 20.0013 22 20.449 22 21.0013C22 21.5535 21.5513 22.0013 20.9978 22.0013H3.15258C2.51603 22.0013 2 21.4864 2 20.8513V2.99869C2 2.4464 2.44872 1.99869 3.00224 1.99869Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10449 11.2353C9.10449 11.9323 8.53949 12.4973 7.84253 12.4973C7.14557 12.4973 6.58057 11.9323 6.58057 11.2353C6.58057 10.5383 7.14557 9.97334 7.84253 9.97334C8.53949 9.97334 9.10449 10.5383 9.10449 11.2353Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2416 8.13962C15.2416 9.15235 14.4206 9.97332 13.4079 9.97332C12.3952 9.97332 11.5742 9.15235 11.5742 8.13962C11.5742 7.1269 12.3952 6.30592 13.4079 6.30592C14.4206 6.30592 15.2416 7.1269 15.2416 8.13962Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8509 14.9727C18.8509 16.4757 17.6325 17.6941 16.1295 17.6941C14.6266 17.6941 13.4082 16.4757 13.4082 14.9727C13.4082 13.4698 14.6266 12.2514 16.1295 12.2514C17.6325 12.2514 18.8509 13.4698 18.8509 14.9727Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1875 14.2918C11.1875 14.6914 10.8635 15.0154 10.4639 15.0154C10.0642 15.0154 9.74023 14.6914 9.74023 14.2918C9.74023 13.8921 10.0642 13.5682 10.4639 13.5682C10.8635 13.5682 11.1875 13.8921 11.1875 14.2918Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPoint);
export default __webpack_public_path__ + "static/media/chart_point.73f678d205ad04f216623d723086b825.svg";
export { ForwardRef as ReactComponent };